import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'selectFilter'
})
export class SelectFilterPipe implements PipeTransform {

  transform(data: any, label?: any, value?: any, empty?: any): any {
    if(data) {
      let result: any = [];
      if (label) {
        for(let val of data) {
          let temp: any = {};
          temp.label = val[label];
          temp.value = val[value];
          result.push(temp);
        }
      } else {
        for(let val of data) {
          let temp: any = {};
          if (val != undefined && val != null) {
            temp.label = val.toUpperCase();
            temp.value = val.toUpperCase();
            result.push(temp);
          }
        }
      }
      let unique_array: any = [];
      if(empty) {
        let temp: any = {};
        temp.label = empty;
        temp.value = null;
        unique_array.push(temp);
      }
      for(let res of result) {
        if(unique_array.length == 0) {
          unique_array.push(res);
        } else {
          let flag = 0;
          for(let uni of unique_array) {
            if(res.value == uni.value) {
              flag = 1;
            }
          }
          if(flag == 0) {
            unique_array.push(res);
          }
        }
      }
      return unique_array;
    }
  }

}
